import { render, staticRenderFns } from "./ofertas.vue?vue&type=template&id=587860a3"
import script from "./ofertas.vue?vue&type=script&lang=js"
export * from "./ofertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports